import React from 'react';

import { Wrapper } from './styled/CountPillStyled';

function CountPill(props: { type?: 'whitelist' | 'blacklist' | ''; count?: number }) {
    return (
        <Wrapper data-testid="CountPill" $type={props.type}>
            {props.count}
        </Wrapper>
    );
}

export default CountPill;
